// Step-up authentication prompt (docs/85 section 9). A 403 with body.code STEP_UP_REQUIRED means
// "prove you hold the second factor, then repeat". One shared prompt serves every request that
// failed at once; cancelling resolves false and the original error propagates.
import React from 'react';
import { Input, Modal, message } from 'antd';
import { t } from '../../i18n/t';

let pending: Promise<boolean> | null = null;

export const requestStepUp = (verify: (code: string) => Promise<unknown>): Promise<boolean> => {
  if (pending) return pending;
  pending = new Promise<boolean>((resolve) => {
    let code = '';
    Modal.confirm({
      title: t('auth:mfa.stepUpTitle'),
      content: (
        <div>
          <p>{t('auth:mfa.stepUpBody')}</p>
          <Input
            autoFocus
            maxLength={8}
            inputMode="numeric"
            autoComplete="one-time-code"
            placeholder={t('auth:mfa.codePlaceholder')}
            onChange={(e) => { code = e.target.value.trim(); }}
          />
        </div>
      ),
      okText: t('auth:mfa.verify'),
      cancelText: t('auth:mfa.cancel'),
      onOk: async () => {
        try {
          await verify(code);
          resolve(true);
        } catch (e) {
          message.error(t('auth:mfa.codeInvalid'));
          throw e; // keeps the dialog open for another try
        }
      },
      onCancel: () => resolve(false),
    });
  }).finally(() => { pending = null; });
  return pending;
};
